<particle-file-selector [(file)]="fileToUpload"
                        [legend]="'Document'"
                        [required]="true" class="w-p-100 flex flex-row">
</particle-file-selector>
<mat-form-field appearance="outline" class="w-p-100 m-t-10">
  <mat-label>Add comment (Optional)</mat-label>
  <textarea [(ngModel)]="message" matInput placeholder=""></textarea>
</mat-form-field>
